import { InfoIcon, Undo2Icon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { VideoTutorials } from '@/entities/video-tutorial'

import { PageNavigatorRegister } from '@/shared/components/PageNavigator'
import { Button } from '@/shared/components/ui/button'
import { VideoTag } from '@/shared/generated'

import { useAnchorsManagementContext } from './AnchorManagementProvider'

export default function AnchorManagementPageToolbar() {
	const { t } = useTranslation()

	const { isDirty, handleSaveChanges, handleRevertChanges } =
		useAnchorsManagementContext()

	return (
		<PageNavigatorRegister>
			<div className='ml-auto flex items-center gap-1'>
				{isDirty && (
					<>
						<Button key='revert' onClick={handleRevertChanges}>
							<Undo2Icon />
							{t('app.revert_changes')}
						</Button>
						<Button key='save' variant='warning' onClick={handleSaveChanges}>
							{t('app.save_and_update')}
						</Button>
					</>
				)}
				<VideoTutorials tags={[VideoTag.Anchors]}>
					<Button size='icon' className='ml-auto' variant='ghost'>
						<InfoIcon />
					</Button>
				</VideoTutorials>
			</div>
		</PageNavigatorRegister>
	)
}
